import { gql, TypedDocumentNode } from '@apollo/client';

export type GetSiteCreditsQuery = {
  credits: {
    __typename: 'RestSiteCredits';
    data: SiteCredit[];
  };
};

export interface SiteCreditAttributes {
  user_id: number;
  order_id?: number;
  order_number: string;
  description: string;
  amount: string;
  currency_unit: string;
  created_at: string;
  updated_at: string;
  reason: number;
  department: number;
}

export type SiteCredit = {
  id: string;
  type: string;
  attributes: SiteCreditAttributes;
};

export const GET_SITE_CREDITS_QUERY: TypedDocumentNode<GetSiteCreditsQuery> = gql`
  query GetSiteCreditsQuery {
    credits @rest(type: "RestSiteCredits", endpoint: "site_credits", path: "/v3.5/site_credits") {
      data @type(name: "RestSiteCreditData") {
        id
        type
        attributes @type(name: "RestSiteCreditAttributes") {
          user_id
          order_id
          order_number
          description
          amount
          currency_unit
          created_at
          updated_at
          reason
          department
        }
      }
    }
  }
`;
